module.exports = __webpack_public_path__ + "static/17-2a8da25a199d9c63dbb9961f35dbe7e6.jpg";